import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Col, Spinner, Button } from 'reactstrap';
import moment from 'moment';
import 'moment/locale/pt-br';
import EyeIcon from 'mdi-react/EyeIcon';
import { Link } from 'react-router-dom';
import { Field, Form } from 'react-final-form';
import CertificadoSelect from '../../Comuns/CertificadoSelect';
import FormField from '@/shared/components/form/FormField';
import renderSelectField from '@/shared/components/form/Select';
import renderIntervalDatePickerField from '@/shared/components/form/IntervalDatePicker';
import ReactTableBase from '../../../shared/components/table/ReactTableBase';
import { fetchSearchInscricoes } from '../../../redux/actions/inscricoesActions';
import { BadgeInscricao } from '../../../shared/components/Badges';
import { listaSituacaoCertificado } from '@/utils/helpers';
import validate from './validate';

const InscricoesList = () => {
  const dispatch = useDispatch();
  const inscricoes = useSelector((state) => state.inscricoes.inscricoes);
  const totalPages = useSelector((state) => state.inscricoes.totalPages);
  const totalItems = useSelector((state) => state.inscricoes.totalItems);
  const isFetching = useSelector((state) => state.inscricoes.isFetching);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState({});
  moment.locale('pt-br');

  const colunas = useMemo(() => [
    {
      Header: 'ALUNO',
      accessor: 'aluno_name',
      disableGlobalFilter: true,
      width: 80,
    },
    {
      Header: 'CERTIFICADO',
      accessor: 'certificado_titulo',
      disableGlobalFilter: true,
      width: 80,
    },
    {
      Header: 'DATA DA INSCRIÇÃO',
      accessor: 'dataInscricao',
      disableGlobalFilter: true,
      width: 80,
    },
    {
      Header: 'TENTATIVAS',
      accessor: 'tentativas',
      disableGlobalFilter: true,
      width: 80,
    },
    {
      Header: 'STATUS',
      accessor: 'status',
      disableGlobalFilter: true,
      width: 80,
    },
    {
      Header: 'AÇÃO',
      accessor: 'acao',
      disableGlobalFilter: true,
      width: 65,
    },
  ]);

  const dadosTabela = (inscricoes) => {
    return inscricoes.map((inscricao) => ({
      aluno_name: inscricao.aluno?.name,
      certificado_titulo: inscricao.certificado?.titulo,
      dataInscricao: moment(inscricao.createdAt).format('DD/MM/YYYY LT'),
      tentativas: inscricao.tentativas?.length,
      status: <BadgeInscricao status={inscricao.status} />,
      acao: (
        <Link
          color="primary"
          className="btn btn-outline-secondary btn-sm list__table-btn-action mb-0 px-2"
          to={`/inscricao/edit/${inscricao._id}`}
        >
          <EyeIcon /> Ver
        </Link>
      ),
    }));
  };

  useEffect(() => {
    dispatch(fetchSearchInscricoes(parseInt(page), pageSize, search));
  }, [dispatch, page, pageSize, search]);

  if (totalPages > 0 && totalPages < page) {
    setPage(totalPages);
  }

  const onSubmit = (data) => {
    const searchForm = {};
    searchForm.filters = {
      status: data.statusSelect?.value,
      certificado: data.certificadoSelect?.value,
    };
    if (data?.createdAt) {
      data.createdAt.start && data.createdAt.start.setHours(0, 0, 0, 0);
      data.createdAt.end && data.createdAt.end.setHours(23, 59, 59, 99);
    }
    searchForm.dateFilters = {
      createdAt: data.createdAt,
    };
    setSearch(searchForm);
  };

  return (
    <Col md={12} lg={12} xl={12}>
      <Card>
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">Inscrições realizadas</h5>
          </div>
          <div className="search__form">
            <Form onSubmit={onSubmit} validate={validate}>
              {({ handleSubmit, form: { submitting } }) => (
                <form
                  className={`form form--horizontal'}`}
                  onSubmit={handleSubmit}
                >
                  <Col xl={4}>
                    <div className="form__form-group">
                      <div className="form__form-group-field">
                        <Field
                          name="statusSelect"
                          component={renderSelectField}
                          type="text"
                          options={[].concat(
                            { value: undefined, label: 'Todos' },
                            listaSituacaoCertificado
                          )}
                          placeholder="Situação"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xl={4}>
                    <CertificadoSelect name="certificadoSelect" />
                  </Col>
                  <Col xl={6}>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        Data da Inscrição
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="createdAt"
                          component={renderIntervalDatePickerField}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xl={6} className="align-self-end text-end">
                    <Button color="primary" type="submit">
                      Pesquisar
                    </Button>
                  </Col>
                </form>
              )}
            </Form>
          </div>
          {isFetching && <Spinner className="table-fetch-spinner" />}
          {inscricoes && !isFetching && (
            <ReactTableBase
              key={'common'}
              columns={colunas}
              data={dadosTabela(inscricoes)}
              tableConfig={{
                isEditable: false,
                isResizable: false,
                isSortable: false,
                withDragAndDrop: false,
                withPagination: true,
                withSearchEngine: false,
                manualPageSize: [10, 20, 30, 40],
                placeholder: 'Search by First name...',
              }}
              setPage={setPage}
              setPageSize={setPageSize}
              currentpage={page}
              pageSize={pageSize}
              totalPages={totalPages}
              totalItems={totalItems}
            />
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default InscricoesList;
